import { UrbanContextType } from '../../../../../../services/types/Calculator';
import { serviceReducer } from '../../../../../../shared/hooks/serviceReducer';
import { Action, ApiState } from '../../../../../../types';

const calculatorSectorReducer = (
  state: ApiState<UrbanContextType, string>,
  action: Action<UrbanContextType, string>
): ApiState<UrbanContextType, string> => serviceReducer(state, action);

export default calculatorSectorReducer;
